import React,{useState, useContext} from 'react'
import {GlobalLangCtx} from '../../App'
import "./SelLangComp.css"

const SelLangComp = () =>
{

  const [uLan, setULan ] = useState('uk')
  const [globalLan, setGlobalLan] = useContext(GlobalLangCtx)

    const handleLan = (language) =>{
      setULan(language)
      setGlobalLan(language)
  }

  return(
    <>
        <div className="rightBlk">
            <ul>
                <li title='cambia linguaggio: IT' className="itemsLan" onClick = { () => handleLan("it") }>It</li>
                <li title='change language: UK' className="itemsLan" onClick = { () => handleLan("uk") }>Uk</li>
            </ul>
        </div>
        {/* <span>Linguaggio: </span> { uLan } */}

      </>
    )
}

export default SelLangComp;